const TAB_ACTIVE =
  "relative flex items-center justify-center gap-1 text-sm/sm whitespace-nowrap transition-colors rounded-card font-medium text-ink shrink-0 px-2.5 py-1 max-mobile:before:absolute max-mobile:before:inset-x-0 max-mobile:before:-inset-y-2 max-mobile:before:content-['']"
const TAB_IDLE =
  "relative flex items-center justify-center gap-1 text-sm/sm whitespace-nowrap transition-colors rounded-card font-normal hover:text-ink active:text-ink shrink-0 hover:bg-ink/5 px-2.5 py-1 text-ink/80 max-mobile:before:absolute max-mobile:before:inset-x-0 max-mobile:before:-inset-y-2 max-mobile:before:content-['']"
const TAB_PILL =
  'absolute inset-0 rounded-card bg-fill shadow-[inset_0_var(--hl-y)_0_0_var(--hl-top),0px_0px_0px_0.5px_var(--ring-crisp),0px_1px_0px_0px_var(--edge-under)] light:border-transparent light:bg-surface light:shadow-[0_0_0_0.5px_var(--ring-crisp),0_1px_0_0_var(--edge-under)] light:shadow-[inset_0_0_0_0.5px_var(--ring-crisp)]!'

export default function FilterTab({ label, pressed, onClick }) {
  return (
    <button
      type="button"
      aria-pressed={pressed ? 'true' : 'false'}
      className={pressed ? TAB_ACTIVE : TAB_IDLE}
      onClick={onClick}
    >
      {pressed ? <span className={TAB_PILL} /> : null}
      <span className="relative z-1 grid place-items-center">
        <span className="col-start-1 row-start-1 flex items-center gap-1.5">
          {label}
        </span>
        <span
          aria-hidden="true"
          className="invisible col-start-1 row-start-1 flex items-center gap-1.5 font-medium"
        >
          {label}
        </span>
      </span>
    </button>
  )
}
